import { formNames, formTypes, propertyTypes, slideNames } from './enums'

const data_hausanker = [
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_0,
    img: '20210625_Teilkauf_2893',
    msg:
      'Sie möchten schnell und unkompliziert Teile Ihres Immobilienvermögens freisetzen? Wir helfen Ihnen gerne dabei.<br /><b>Nennen Sie uns bitte zunächst Ihren Immobilientyp.</b>',
    msgV2:
      'Wir begleiten Sie auf dem Weg zu Ihrem unverbindlichen Teilverkaufs-Angebot.',
    msgVar: '',
    forNext: 'one',
    nextEnabled: false,
    backButton: false,
    align: 'center',
    propertyTypes: [propertyTypes.HOUSE, propertyTypes.APARTMENT],
    forms: [
      {
        slideName: slideNames.SLIDE_0,
        formName: formNames.FORM_0_1,
        heading: 'Ihr Immobilientyp',
        headingV2: 'Wahlen Sie Ihren Immobilientyp',
        headingMargin: 'small',
        inputs: [
          {
            slideName: slideNames.SLIDE_0,
            formName: formNames.FORM_0_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-31.svg',
            imgV2: 'Haus.svg',
            label: 'Haus',
            name: 'haus',
            value: propertyTypes.HOUSE,
            propertyType: propertyTypes.HOUSE
          },
          {
            slideName: slideNames.SLIDE_0,
            formName: formNames.FORM_0_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-32.svg',
            imgV2: 'Wohnung.svg',
            label: 'Wohnung',
            name: 'wohnung',
            msg_1: 'Ihrer Wohnung',
            value: propertyTypes.APARTMENT,
            propertyType: propertyTypes.APARTMENT
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_1,
    img: '20210625_Teilkauf_2893',
    msg: '<b>Bitte nennen Sie uns noch den Haustyp Ihrer Immobilie.</b>',
    msgVar: '',
    forNext: 'one',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_1,
        formName: formNames.FORM_1_1,
        heading: 'Ihr Haustyp',
        headingMargin: 'small',
        inputs: [
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-1.svg',
            imgV2: 'Einfamilienhaus.svg',
            label: 'Einfamilienhaus <br /> (Freistehend)',
            name: 'Einfamilienhaus (Freistehend)',
            hausType: 1,
            value: 'freistehend',
            value_0: 'Einfamilienhaus',
            msg_1: 'Ihr Einfamilienhaus',
            msg_2: 'Ihres Einfamilienhauses',
            msg_3: 'Ihrem Einfamilienhaus'
          },
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-2.svg',
            imgV2: 'Reihenhaus.svg',
            label: 'Doppelhaushälfte',
            name: 'Doppelhaushälfte',
            hausType: 2,
            value: 'Doppelhaushaelfte',
            value_0: 'Einfamilienhaus',
            msg_1: 'Ihre Doppelhaushälfte',
            msg_2: 'Ihrer Doppelhaushälfte',
            msg_3: 'Ihrer Doppelhaushälfte'
          },
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-3.svg',
            imgV2: 'Reihenendhaus.svg',
            label: 'Reihenendhaus',
            name: 'Reihenendhaus',
            hausType: 3,
            value: 'Reihenendhaus',
            value_0: 'Einfamilienhaus',
            msg_1: 'Ihr Reihenendhaus',
            msg_2: 'Ihres Reihenendhauses',
            msg_3: 'Ihrem Reihenendhaus'
          },
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-4.svg',
            imgV2: 'Reihenmittelhaus.svg',
            label: 'Reihenmittelhaus',
            name: 'Reihenmittelhaus',
            hausType: 5,
            value: 'Reihenmittelhaus',
            value_0: 'Einfamilienhaus',
            msg_1: 'Ihr Reihenmittelhaus',
            msg_2: 'Ihres Reihenmittelhauses',
            msg_3: 'Ihrem Reihenmittelhaus'
          },
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-5.svg',
            imgV2: 'Einliegerwohnung.svg',
            label: 'Einfamilienhaus </br>  mit Einliegerwohnung',
            name: 'Einfamilienhaus mit Einliegerwohnung',
            hausType: 4,
            value: 'freistehend',
            value_0: 'EinfamilienhausmitEinliegerwohnung',
            msg_1: 'Ihr Einfamilienhaus',
            msg_2: 'Ihres Einfamilienhauses',
            msg_3: 'Ihrem Einfamilienhaus'
          },
          {
            slideName: slideNames.SLIDE_1,
            formName: formNames.FORM_1_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-6.svg',
            imgV2: 'Zweifamilienhaus.svg',
            label: 'Zweifamilienhaus',
            name: 'zweifamilienhaus',
            hausType: 6,
            value: 'freistehend',
            value_0: 'Zweifamilienhaus',
            msg_2: 'Ihres Zweifamilienhauses',
            msg_3: 'Ihrem Zweifamilienhaus'
          }
          // {
          //   slideName: slideNames.SLIDE_1,
          //   formName: formNames.FORM_1_1,
          //   type: formTypes.RADIO_BOX,
          //   selectedValue: '',
          //   img: 'item-7.svg',
          //   imgV2: 'Mehrfamilienhaus.svg',
          //   label: 'Mehrfamilienhaus',
          //   name: 'Mehrfamilienhaus',
          //   hausType: 7,
          //   value: 'freistehend',
          //   value_0: 'Mehrfamilienhaus',
          //   msg_1: 'Ihr Mehrfamilienhaus',
          //   msg_2: 'Ihres Mehrfamilienhauses',
          //   msg_3: 'Ihrem Mehrfamilienhaus'
          // }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_2,
    img: '20210625_Teilkauf_2897',
    msg:
      '<b>Wie hoch ist der geschätzte Wert <VAR> und welche Auszahlungshöhe wünschen Sie sich?</b><br />(mind. 100.000 €, max. 50 % des Gesamtwerts)',
    msgVar: '',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_2,
        formName: formNames.FORM_2_1,
        heading: 'Ihr geschätzter Immobilienwert',
        marginBottom: 'big',
        forNext: 'all',
        inputs: [
          {
            slideName: slideNames.SLIDE_2,
            formName: formNames.FORM_2_1,
            name: 'Immobilienwert',
            type: formTypes.RANGE,
            default: formNames.FORM_2_1.value,
            min: 200000,
            max: 2000000,
            numberMax: 5000000,
            step: 1000,
            unit: '€',
            selectedValue: '',
            isInvalid: false,
            validations: {
              messageMin:
                'Bitten geben Sie mindestens einen Wert von 200.000 € an.',
              messageMax:
                'Bitten geben Sie höchstens einen Wert von 5.000.000 € an.'
            }
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_2,
        formName: formNames.FORM_2_2,
        heading: 'Ihre Wunschauszahlung',
        forNext: 'all',
        inputs: [
          {
            slideName: slideNames.SLIDE_2,
            formName: formNames.FORM_2_2,
            name: 'Wunschauszahlung',
            type: formTypes.RANGE,
            default: formNames.FORM_2_2.value,
            min: 100000,
            max: 250000,
            step: 1000,
            unit: '€',
            selectedValue: '',
            isInvalid: false,
            validations: {
              messageMin:
                'Bitten geben Sie mindestens einen Wert von 100.000 € an.',
              messageMax:
                'Ihre Wunschauszahlung darf 50 % des geschätzten Immobilienwertes (Ihr geschätzter Immobilienwert) nicht übersteigen.'
            }
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_3,
    img: '20210625_Teilkauf_2926',
    msg:
      '<b>Bestehen bei Ihrer Immobilie Lasten, wie beispielsweise eine Hypothek oder eine Grundschuld?</b><br />Falls ja: Diese dürfen die von Ihnen gewählte Wunschauszahlung nicht übersteigen.',
    forNext: 'combined',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_3,
        formName: formNames.FORM_3_1,
        heading: 'Lasten der Immobilie',
        headingMargin: 'small',
        marginBottom: 'big',
        forNext: 'one',
        inputs: [
          {
            slideName: slideNames.SLIDE_3,
            formName: formNames.FORM_3_1,
            type: formTypes.RADIO_BOX,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_3,
            formName: formNames.FORM_3_1,
            type: formTypes.RADIO_BOX,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_3,
        formName: formNames.FORM_3_2,
        heading: 'Höhe der Lasten',
        tooltip:
          'Die Lasten dürfen nicht höher sein als der Wunsch&shy;aus&shy;zahlungs&shy;betrag.',
        showForm: false,
        forNext: 'all',
        inputs: [
          {
            slideName: slideNames.SLIDE_3,
            formName: formNames.FORM_3_2,
            name: 'Höhe der Lasten',
            type: formTypes.RANGE,
            default: 1000,
            min: 1000,
            max: 100000,
            step: 1000,
            unit: '€',
            selectedValue: '',
            validations: {
              messageMin:
                'Bitten geben Sie mindestens einen Wert von 1.000 € an.',
              messageMax:
                'Die Lasten dürfen den Wunschauszahlungsbetrag (Ihre Wunschauszahlung) nicht übersteigen.'
            }
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_19,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Tragen Sie hier bitte die Adresse <VAR> ein.</b><br />Durch die Angabe der Lage können wir eine genauere Immobilienbewertung vornehmen.',
    forNext: 'validation',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    msgVar: '',
    align: 'center',
    gif: true,
    gifImg: 'weiterzu.svg',
    forms: [
      {
        slideName: slideNames.SLIDE_19,
        formName: formNames.FORM_19_1,
        img: 'item-30.svg',
        imgV2: 'Standort.svg',
        heading: 'Adresse der Immobilie',
        heading_2:
          'Später können Sie optional eine abweichende Anschrift für die Zusendung Ihres Angebots angeben.',
        headingMargin: 'big',
        grid: 'space-between',
        additionalInfo_1: 'Warum fragen wir das?',
        additionalInfo_2:
          'Unsere Immobilienbewertung bezieht insbesondere die Lage der Immobilie für ein genaueres Ergebnis ein.',
        inputs: [
          {
            slideName: slideNames.SLIDE_19,
            formName: formNames.FORM_19_1_1,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 255,
              noNumber: true,
              message:
                'Bitte geben Sie die Hausnummer in dem dafür vorgesehenen Feld an.'
            },
            label: 'Strasse',
            name: 'Strasse',
            width: '3-4'
          },
          {
            slideName: slideNames.SLIDE_19,
            formName: formNames.FORM_19_1_2,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 10,
              minOneNumber: true,
              noSingleZero: true,
              message: 'Bitte geben Sie Ihre Hausnummer an.'
            },
            label: 'Hausnummer',
            name: 'Hausnummer',
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_19,
            formName: formNames.FORM_19_2,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            inputType: 'number',
            label: 'Postleitzahl',
            name: 'Postleitzahl',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              numeric: true,
              minLength: 5,
              maxLength: 5,
              message: 'Bitte geben Sie Ihre korrekte Postleitzahl an.'
            },
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_19,
            formName: formNames.FORM_19_3,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Stadt',
            name: 'Stadt',
            width: '3-4',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              noNumber: true,
              message:
                'Bitte geben Sie die Postleitzahl in dem dafür vorgesehenen Feld an.'
            }
          },
          {
            slideName: slideNames.SLIDE_19,
            formName: formNames.FORM_19_4,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Bundesland',
            name: 'Bundesland',
            width: '3-4',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              noNumber: true,
              message:
                'Bitte geben Sie die Postleitzahl in dem dafür vorgesehenen Feld an.'
            }
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_4,
    img: '20210625_Teilkauf_2849',
    msg:
      '<b>Bitte geben Sie nun die Anzahl der Etagen sowie die Grundstücksfläche <VAR> an.</b>',
    msgVar: '',
    forNext: 'validation',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE],
    grid: 'row',
    forms: [
      {
        slideName: slideNames.SLIDE_4,
        formName: formNames.FORM_4_1,
        inputs: [
          {
            slideName: slideNames.SLIDE_4,
            formName: formNames.FORM_4_1,
            name: 'Anzahl der Geschosse',
            type: formTypes.RANGE,
            img: 'item-8.svg',
            imgV2: 'Geschosse.svg',
            width: 'half',
            heading: 'Anzahl der Geschosse',
            heading_2: '(ohne Dachgeschoss und Kellergeschoss)',
            minWidthHeading2: true,
            default: 1,
            min: 1,
            max: 4,
            numberMax: 4,
            step: 1,
            unit: '',
            selectedValue: '',
            format: false,
            isInvalid: false,
            validations: {
              required: true,
              messageMin: '',
              messageMax: 'Bitten geben Sie höchstens einen Wert von 4 an.'
            }
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_4,
        formName: formNames.FORM_4_2,
        inputs: [
          {
            slideName: slideNames.SLIDE_4,
            formName: formNames.FORM_4_2,
            type: formTypes.RANGE,
            name: 'Grundstücksfläche',
            img: 'item-9.svg',
            imgV2: 'Grundstuckflache.svg',
            heading: 'Grundstücksfläche',
            minWidthHeading2: true,
            default: 50,
            width: 'half',
            min: 50,
            max: 2000,
            numberMax: 10000,
            step: 1,
            unit: 'm²',
            selectedValue: '',
            isInvalid: true,
            validations: {
              messageMin: 'Bitten geben Sie mindestens einen Wert von 50m² an.',
              messageMax:
                'Bitten geben Sie höchstens einen Wert von 10.000 m² an.'
            },
            secondInput: true
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_5,
    img: '20210625_Teilkauf_2850',
    msg:
      'Vielen Dank.<br /><b>Nennen Sie uns bitte noch das Baujahr sowie die Wohnfläche <VAR>.</b> ',
    msgVar: '',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    grid: 'row',
    forms: [
      {
        slideName: slideNames.SLIDE_5,
        formName: formNames.FORM_5_1,
        inputs: [
          {
            slideName: slideNames.SLIDE_5,
            formName: formNames.FORM_5_1,
            name: 'Baujahr',
            tooltip:
              'Sofern Ihnen das konkrete Baujahr nicht bekannt ist, können Sie gerne schätzen.',
            type: formTypes.RANGE,
            img: 'item-10.svg',
            imgV2: 'Baujahr.svg',
            heading: 'Baujahr',
            default: formNames.FORM_5_1.value,
            format: false,
            width: 'half',
            min: 1700,
            max: 2021,
            step: 1,
            unit: '',
            selectedValue: '',
            isInvalid: false,
            validations: {
              messageMin: 'Das Baujahr kann nicht vor 1700 liegen.',
              messageMax: 'Das Baujahr kann nicht nach 2021 liegen.'
            }
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_5,
        formName: formNames.FORM_5_2,
        inputs: [
          {
            slideName: slideNames.SLIDE_5,
            formName: formNames.FORM_5_2,
            type: formTypes.RANGE,
            name: 'Wohnfläche',
            heading: 'Wohnfläche',
            default: formNames.FORM_5_2.value,
            width: 'half',
            img: 'item-11.svg',
            imgV2: 'Wohnflache.svg',
            min: 50,
            max: 500,
            numberMax: 1000,
            step: 1,
            unit: 'm²',
            selectedValue: '',
            secondInput: true,
            isInvalid: false,
            validations: {
              messageMin: 'Bitten geben Sie mindestens einen Wert von 50 m² an',
              messageMax:
                'Bitten geben Sie höchstens einen Wert von 1.000 m² an.'
            }
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_23,
    img: '20210625_Teilkauf_2850',
    msg: '<b>Können Sie uns bitte etwas über die Immobilie erzählen?</b>',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT],
    grid: 'col',
    forms: [
      {
        slideName: slideNames.SLIDE_23,
        formName: formNames.FORM_23_1,
        headingMargin: 'medium',
        marginBottom: 'medium',
        heading: 'Geschosslage der Wohnung',
        inputs: [
          {
            slideName: slideNames.SLIDE_23,
            formName: formNames.FORM_23_1,
            type: formTypes.SELECT,
            placeholder: 'Bitte wählen Sie aus',

            name: 'Geschosslage',
            style: 'center',
            selectedValue: '',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: 'Untergeschoss',
                value: 'Untergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: 'Erdgeschoss',
                value: 'Erdgeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '1. Obergeschoss',
                value: '1_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '2. Obergeschoss',
                value: '2_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '3. Obergeschoss',
                value: '3_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '4. Obergeschoss',
                value: '4_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '5. Obergeschoss',
                value: '5_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '6. Obergeschoss',
                value: '6_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '7. Obergeschoss',
                value: '7_Obergeschoss'
              },
              {
                slideName: slideNames.SLIDE_23,
                formName: formNames.FORM_23_1,
                label: '+8 Geschosse',
                value: 'ueber8Geschosse'
              }
            ]
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_23,
        formName: formNames.FORM_23_2,
        tooltip:
          'Wenn Sie nicht genau wissen sollten, wie viele Wohneinheiten in Ihrer Immobilie vorhanden sind, können Sie auch grob schätzen.',
        heading: 'Wohneinheiten der Immobilie',
        inputs: [
          {
            slideName: slideNames.SLIDE_23,
            formName: formNames.FORM_23_2,
            type: formTypes.RANGE,
            name: 'Wohneinheiten der Immobilie',
            default: formNames.FORM_23_2.value,
            min: 1,
            max: 100,
            numberMax: 500,
            step: 1,
            unit: '',
            selectedValue: '',
            isInvalid: false,
            validations: {
              messageMin: 'Bitten geben Sie mindestens einen Wert von 1 an.',
              messageMax: 'Bitten geben Sie höchstens einen Wert von 500 an.'
            }
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_6,
    img: '20210625_Teilkauf_2926',
    msg: '<b>In welcher Bauweise wurde <VAR> erbaut?</b>',
    msgVar: '',
    forNext: 'one',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE],
    align: 'center',
    forms: [
      {
        slideName: slideNames.SLIDE_6,
        formName: formNames.FORM_6_1,
        heading: 'Bauweise',
        tooltip: 'Massivbau: Mauerwerk, Beton, Stahlbeton oder Spannbeton',
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_6,
            formName: formNames.FORM_6_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-12.svg',
            imgV2: 'Massivbau.svg',
            label: 'Massivbau',
            name: 'Massivbau',
            value: 'Massiv'
          },
          {
            slideName: slideNames.SLIDE_6,
            formName: formNames.FORM_6_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-13.svg',
            imgV2: 'Fertigbau massiv.svg',
            label: 'Fertigbau <br /> (Massiv)',
            name: 'Fertigbau (Massiv)',
            value: 'Fertighausmassiv'
          },
          {
            slideName: slideNames.SLIDE_6,
            formName: formNames.FORM_6_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-14.svg',
            imgV2: 'Fertigbau Holz.svg',
            label: 'Fertigbau <br /> (Holz)',
            name: 'Fertigbau (Holz)',
            value: 'FertighausHolz'
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_7,
    img: '20210625_Teilkauf_2926',
    msg:
      '<b>Verfügt <VAR> über einen Keller?</b><br />Der Ausbau bezieht sich auf die Wohnfläche.',
    msgVar: '',
    forNext: 'check-combined',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_7,
        formName: formNames.FORM_7_1,
        type: formTypes.RADIO_COMBO,
        heading: 'Ausbau des Kellers',
        forNext: 'one',
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_7,
            formName: formNames.FORM_7_1,
            type: formTypes.RADIO_COMBO,
            optionHeading: 'Ausbaustufe',
            optionHeading_2: 'Bitte wählen Sie aus:',
            selectedValue: '',
            showOptions: false,
            img: 'item-15.svg',
            imgV2: 'Vollunterkellert.svg',
            label: 'Vollunterkellert',
            name: 'Vollunterkellert',
            value: 'vollunterkellert',
            options: [
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                inputName: 'Vollunterkellert',
                selectedValue: '',
                label: 'Nicht ausgebaut',
                name: 'Nicht ausgebaut 1',
                value: 'nichtausgebaut'
              },
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                inputName: 'Vollunterkellert',
                selectedValue: '',
                label: 'Teilweise ausgebaut',
                name: 'Teilweise ausgebaut 1',
                value: 'teilweiseausgebaut'
              },
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                inputName: 'Vollunterkellert',
                selectedValue: '',
                label: 'Komplett ausgebaut',
                name: 'Komplett ausgebaut 1',
                value: 'vollausgebaut'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_7,
            formName: formNames.FORM_7_1,
            type: formTypes.RADIO_COMBO,
            optionHeading: 'Ausbaustufe',
            optionHeading_2: 'Bitte wählen Sie aus:',
            selectedValue: '',
            img: 'item-16.svg',
            imgV2: 'Teilunterkellert.svg',
            showOptions: false,
            value: 'teilweiseunterkellert',
            label: 'Teilweise <br /> unterkellert',
            name: 'Teilweise unterkellert',
            options: [
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                selectedValue: '',
                label: 'Nicht ausgebaut',
                inputName: 'Teilweise unterkellert',
                name: 'Nicht ausgebaut 2',
                value: 'nichtausgebaut'
              },
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                selectedValue: '',
                label: 'Teilweise ausgebaut',
                inputName: 'Teilweise unterkellert',
                name: 'Teilweise ausgebaut 2',
                value: 'teilweiseausgebaut'
              },
              {
                slideName: slideNames.SLIDE_7,
                formName: formNames.FORM_7_2,
                type: formTypes.RADIO_COMBO,
                selectedValue: '',
                label: 'Komplett ausgebaut',
                inputName: 'Teilweise unterkellert 2',
                name: 'Komplett ausgebaut',
                value: 'vollausgebaut'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_7,
            formName: formNames.FORM_7_1,
            type: formTypes.RADIO_COMBO,
            selectedValue: '',
            img: 'item-17.svg',
            imgV2: 'Nicht_unterkellert.svg',
            value: 'nichtunterkellert',
            label: 'Nicht <br /> unterkellert',
            name: 'Nicht unterkellert'
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_8,
    img: '20210625_Teilkauf_2850',
    msg: '<b>Wurde Ihr Dachboden zu Wohnraum ausgebaut?</b>',
    msgVar: '',
    forNext: 'one',
    nextEnabled: false,
    align: 'center',
    propertyTypes: [propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_8,
        formName: formNames.FORM_8_1,
        heading: 'Dachgeschoss',
        headingMargin: 'medium',
        width: 'wide',
        inputs: [
          {
            slideName: slideNames.SLIDE_8,
            formName: formNames.FORM_8_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-18.svg',
            imgV2: 'Dach ausgebaut.svg',
            label: 'Voll <br /> ausgebaut',
            name: 'Voll ausgebaut',
            value: 'vollausgebaut'
          },
          {
            slideName: slideNames.SLIDE_8,
            formName: formNames.FORM_8_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-19.svg',
            imgV2: 'Dach ausgebaut_1.svg',
            label: 'Teilweise <br /> ausgebaut',
            name: 'Teilweise ausgebaut',
            value: 'teilweiseausgebaut'
          },
          {
            slideName: slideNames.SLIDE_8,
            formName: formNames.FORM_8_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-20.svg',
            imgV2: 'Nicht ausgebaut.svg',
            label: 'Nicht <br /> ausgebaut',
            name: 'Nicht ausgebaut',
            value: 'nichtausgebaut'
          },
          {
            slideName: slideNames.SLIDE_8,
            formName: formNames.FORM_8_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-21.svg',
            imgV2: 'Flachdach.svg',
            label: 'Flachdach',
            name: 'flachdach',
            value: 'Flachdach'
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_9,
    img: '20210625_Teilkauf_2893',
    msg: '<b>Bitte nennen Sie uns die Anzahl der Parkplätze.</b>',
    msgVar: '',
    forNext: 'combined',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE, propertyTypes.APARTMENT],
    heading: 'Ihre Stellplätze',
    forms: [
      {
        slideName: slideNames.SLIDE_9,
        formName: formNames.FORM_9_1,
        grid: 'row',
        heading: 'Anzahl der',
        heading_2: 'Garagenstellplätze',
        forNext: 'one',
        img: 'item-22.svg',
        imgV2: 'Garagenstellplatz.svg',
        align: 'around',
        border: 'bottom',
        inputs: [
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_1,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: 'Keine',
            name: 'Keine',
            value: 'keine'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_1,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '1',
            name: '1',
            value: '1'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_1,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '2',
            name: '2',
            value: '2'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_1,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '3',
            name: '3',
            value: '3'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_1,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '4',
            name: '4',
            value: '4'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_9,
        formName: formNames.FORM_9_2,
        type: formTypes.RADIO_VERTICAL,
        border: 'bottom',
        align: 'around',
        grid: 'row',
        forNext: 'one',
        heading: 'Anzahl der ',
        heading_2: 'Stellplätze im Freien',
        img: 'item-23.svg',
        imgV2: 'Stellplatz im Freien.svg',
        inputs: [
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_2,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: 'Keine',
            name: 'Keine',
            value: 'keine'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_2,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '1',
            name: '1',
            value: '1'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_2,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '2',
            name: '2',
            value: '2'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_2,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '3',
            name: '3',
            value: '3'
          },
          {
            slideName: slideNames.SLIDE_9,
            formName: formNames.FORM_9_2,
            type: formTypes.RADIO_VERTICAL,
            selectedValue: '',
            label: '4',
            name: '4',
            value: '4'
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_10,
    img: '20210625_Teilkauf_2926',
    msg:
      '<b>Verfügt Ihre Wohnung über einen Balkon/eine Terrasse oder einen Garten?</b>',
    msgVar: '',
    forNext: 'manual',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT],
    forms: [
      {
        slideName: slideNames.SLIDE_10,
        formName: formNames.FORM_10_1,
        type: formTypes.RADIO_COMBO,
        heading: 'Ausstattung',
        forNext: 'one',
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_10,
            formName: formNames.FORM_10_1,
            type: formTypes.RADIO_COMBO,
            selectedValue: '',
            img: 'item-24.svg',
            imgV2: 'Balkon.svg',
            label: 'Balkon / Terrasse',
            name: 'Balkon Terrasse',
            value: 'balkon/terrasse',
            showOptions: false,
            optionHeading: 'Fläche',
            optionHeading_2: 'Bitte wählen Sie aus:',
            options: [
              {
                slideName: slideNames.SLIDE_10,
                formName: formNames.FORM_10_1,
                type: formTypes.RADIO_COMBO,
                selectedValue: '',
                inputName: 'Balkon Terrasse',
                label: 'bis 10 m²',
                name: 'bis 10m2',
                value: 'bis 10m2'
              },
              {
                slideName: slideNames.SLIDE_10,
                formName: formNames.FORM_10_1,
                type: formTypes.RADIO_COMBO,
                inputName: 'Balkon Terrasse',
                selectedValue: '',
                label: 'über 10 m²',
                name: 'ueber 10m2',
                value: 'ueber 10m2'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_10,
            formName: formNames.FORM_10_2,
            type: formTypes.RADIO_COMBO,
            selectedValue: '',
            showOptions: false,
            img: 'item-25.svg',
            imgV2: 'Garten.svg',
            label: 'Garten',
            name: 'Garten',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_10,
            formName: formNames.FORM_10_2,
            type: formTypes.RADIO_COMBO,
            selectedValue: '',
            showOptions: false,
            img: 'item-26.svg',
            imgV2: 'Kein.svg',
            label: 'Keine',
            name: 'Keine',
            value: 'Nein'
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_11,
    img: '20210625_Teilkauf_2850',
    msg:
      'Vielen Dank, Sie haben es bald geschafft. <b>Verfügt <VAR> über …</b>',
    msgVar: '',
    forNext: 'combined',
    nextEnabled: false,
    heading: 'Wählen Sie Ihre Ausstattung',
    propertyTypes: [propertyTypes.HOUSE],
    grid: 'row',
    height: 'small',
    forms: [
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_3,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… ein seperates Gäste-WC?',
        headingHeight: 'small',
        marginTop: 'medium',
        forNext: 'one',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_3,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_3,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_2,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… einen offenen Kamin oder Kachelofen?',
        headingHeight: 'small',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_2,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_2,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_1,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… mehr als ein Bad',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_1,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_1,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_6,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… Leitungen die überwiegend auf Putz (sichtbar) liegen?',
        headingHeight: 'small',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_6,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_6,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_4,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… eine Sauna?',
        headingHeight: 'small',
        marginTop: 'medium',
        forNext: 'one',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_4,
            type: formTypes.MULTI_CHECKS,
            selectedValue: '',
            shape: 'rectangle',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_4,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_11,
        formName: formNames.FORM_11_5,
        type: formTypes.MULTI_CHECKS,
        heading_2: '… Außenwände die überwiegend gedämmt sind?',
        headingHeight: 'small',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_5,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_11,
            formName: formNames.FORM_11_5,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_12,
    img: '20210625_Teilkauf_2893',
    msg:
      'Vielen Dank, Sie haben es bald geschafft.<br /><b>Nun erzählen Sie uns bitte etwas über die Ausstattung Ihrer Wohnung.</b>',
    msgVar: '',
    forNext: 'combined',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT],
    heading: 'Wählen Sie Ihre Ausstattung',
    grid: 'row',
    height: 'small',
    forms: [
      {
        slideName: slideNames.SLIDE_12,
        formName: formNames.FORM_12_1,
        type: formTypes.MULTI_CHECKS,
        heading_2: 'Sind die Außenwände überwiegend gedämmt?',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_12,
            formName: formNames.FORM_12_1,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_12,
            formName: formNames.FORM_12_1,
            type: formTypes.MULTI_CHECKS,
            shape: 'rectangle',
            selectedValue: '',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      },
      {
        slideName: slideNames.SLIDE_12,
        formName: formNames.FORM_12_2,
        type: formTypes.MULTI_CHECKS,
        heading_2: 'Besitzt die Wohnung ein separates Gäste WC?',
        forNext: 'one',
        marginTop: 'medium',
        height: 'fixed',
        headingWidth: 'fixed',
        inputs: [
          {
            slideName: slideNames.SLIDE_12,
            formName: formNames.FORM_12_2,
            type: formTypes.MULTI_CHECKS,
            selectedValue: '',
            shape: 'rectangle',
            label: 'Ja',
            name: 'ja',
            value: 'Ja'
          },
          {
            slideName: slideNames.SLIDE_12,
            formName: formNames.FORM_12_2,
            type: formTypes.MULTI_CHECKS,
            selectedValue: '',
            shape: 'rectangle',
            label: 'Nein',
            name: 'nein',
            value: 'Nein'
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_13,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Was können Sie uns über folgende Objektinformationen verraten?</b>',
    msgVar: '',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE],
    grid: 'col',
    forms: [
      {
        slideName: slideNames.SLIDE_13,
        formName: formNames.FORM_13_1,
        heading: 'Objektinformationen',
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_13,
            formName: formNames.FORM_13_1,
            type: formTypes.SELECT,
            placeholder: 'Bitte wählen Sie aus',
            selectedValue: '',
            style: 'center',
            label: 'Heizung',
            name: 'heizung',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_1,
                label: 'Einzelöfen',
                value: 'Einzeloefen'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_1,
                label: 'Fußbodenheizung',
                value: 'Fussbodenheizung'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_1,
                label: 'Gebäude oder Zentralheizung',
                value: 'GebaeudeoderWohnungszentralheizung'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_1,
                label: 'sonstige (z.B. Nachtspeicherheizung)',
                value: 'sonstige'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_13,
            formName: formNames.FORM_13_3,
            type: formTypes.SELECT,
            selectedValue: '',
            placeholder: 'Bitte wählen Sie aus',
            label: 'Fenster',
            name: 'fenster',
            style: 'center',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'einfach verglast',
                value: 'einfachverglast'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'zweifach verglast',
                value: 'zweifachverglast'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'dreifach verglast',
                value: 'dreifachverglast'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'Kastenfenster',
                value: 'Kastenfenster'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'große feststehende Fensterflächen',
                value: 'großefeststehendeFensterflaechen'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'Spezialverglasung',
                value: 'Spezialverglasung'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_3,
                label: 'sonstige',
                value: 'sonstige'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_13,
            formName: formNames.FORM_13_2,
            type: formTypes.SELECT,
            selectedValue: '',
            placeholder: 'Bitte wählen Sie aus',
            label: 'Dacheindeckung',
            name: 'dacheindeckung',
            style: 'center',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_2,
                label: 'Dachpappe',
                value: 'Dachpappe'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_2,
                label: 'Dachpfannen/ziegel',
                value: 'Dachpfannen'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_2,
                label: 'Kunstschiefer',
                value: 'Kunstschiefer'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_2,
                label: 'Naturschiefer/Metall',
                value: 'NaturschieferMetall'
              },
              {
                slideName: slideNames.SLIDE_13,
                formName: formNames.FORM_13_2,
                label: 'sonstige',
                value: 'sonstige'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_14,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Was können Sie uns über folgende Objektinformationen verraten?</b>',
    msgVar: '',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT],
    grid: 'col',
    forms: [
      {
        slideName: slideNames.SLIDE_14,
        formName: formNames.FORM_14_1,
        heading: 'Objektinformationen',
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_14,
            formName: formNames.FORM_14_1,
            type: formTypes.SELECT,
            selectedValue: '',
            placeholder: 'Bitte wählen Sie aus',
            style: 'center',
            label: 'Fenster',
            name: 'fenster',
            marginSize: 'medium',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'einfach verglast',
                value: 'einfachverglast'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'zweifach verglast',
                value: 'zweifachverglast'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'dreifach verglast',
                value: 'dreifachverglast'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'Kastenfenster',
                value: 'Kastenfenster'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'große feststehende Fensterflächen',
                value: 'großefeststehendeFensterflaechen'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_1,
                label: 'Spezialverglasung',
                value: 'Spezialverglasung'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_14,
            formName: formNames.FORM_14_2,
            type: formTypes.SELECT,
            label: 'Bad',
            marginSize: 'medium',
            name: 'bad',
            selectedValue: '',
            style: 'center',
            placeholder: 'Bitte wählen Sie aus',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_2,
                label: 'innenliegend',
                value: 'innenliegend'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_2,
                label: 'mit Fenster',
                value: 'mitFenster'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_2,
                label: 'mehr als ein Bad',
                value: 'mehralseinBad'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_14,
            formName: formNames.FORM_14_3,
            type: formTypes.SELECT,
            selectedValue: '',
            style: 'center',
            marginSize: 'medium',
            placeholder: 'Bitte wählen Sie aus',
            label: 'Heizung',
            name: 'heizung',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_3,
                label: 'Einzelöfen',
                value: 'Einzeloefen'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_3,
                label: 'Fußbodenheizung',
                value: 'Fussbodenheizung'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_3,
                label: 'Gebäude oder Zentralheizung',
                value: 'GebaeudeoderWohnungszentralheizung'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_3,
                label: 'sonstige (z.B. Nachtspeicherheizung)',
                value: 'sonstige'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_14,
            formName: formNames.FORM_14_4,
            type: formTypes.SELECT,
            placeholder: 'Bitte wählen Sie aus',
            selectedValue: '',
            marginSize: 'medium',
            label: 'Abstellraum',
            name: 'abstellraum',
            style: 'center',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_4,
                label: 'keiner',
                value: 'keiner'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_4,
                label: 'innerhalb der Wohnung',
                value: 'innerhalbderWohnung'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_4,
                label: 'außerhalb der Wohnung',
                value: 'ausserhalbderWohnung'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_4,
                label: 'innerhalb und außerhalb der Wohnung',
                value: 'innerhalbundausserhalb'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_14,
            formName: formNames.FORM_14_5,
            type: formTypes.SELECT,
            selectedValue: '',
            placeholder: 'Bitte wählen Sie aus',
            style: 'center',
            marginSize: 'medium',
            label: 'Fußbodenbelag (überwiegend)',
            name: 'fußbodenbelag',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_5,
                label: 'Kunststoff/PVC',
                value: 'KunststoffPVC'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_5,
                label: 'Fliesen',
                value: 'Fliesen'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_5,
                label: 'Parkett',
                value: 'ParkettNaturstein'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_5,
                label: 'Teppich/Laminat',
                value: 'TeppichLaminat'
              },
              {
                slideName: slideNames.SLIDE_14,
                formName: formNames.FORM_14_5,
                label: 'sonstiges',
                value: 'sonstiges'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_16,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Welche Energieeffizienz hat <VAR>?</b><br />Die Werte finden Sie in Ihrem Energieausweis.',
    msgVar: '',
    forNext: 'all',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    grid: 'col',
    forms: [
      {
        slideName: slideNames.SLIDE_16,
        formName: formNames.FORM_16_1,
        inputs: [
          {
            slideName: slideNames.SLIDE_16,
            formName: formNames.FORM_16_1,
            type: formTypes.SELECT,
            placeholder: 'Bitte wählen Sie aus',
            label: 'Energieeffizienzklasse',
            name: 'energieeffizienzklasse',
            style: 'center',
            selectedValue: '',
            labelSize: 'big',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'k.A.',
                value: 'kA'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'A+',
                value: 'Aplus'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'A',
                value: 'A'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'B < 75 kWh/(m2·a)',
                value: 'B'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'C < 100 kWh/(m2·a)',
                value: 'C'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'D < 130 kWh/(m2·a)',
                value: 'D'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'E < 160 kWh/(m2·a)',
                value: 'E'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'F < 200 kWh/(m2·a)',
                value: 'F'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'G < 250 kWh/(m2·a)',
                value: 'G'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_1,
                label: 'H > 250 kWh/(m2·a)',
                value: 'H'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_16,
            formName: formNames.FORM_16_2,
            type: formTypes.SELECT,
            selectedValue: '',
            placeholder: 'Bitte wählen Sie aus',
            style: 'center',
            label: 'Energieeffizienzhausstandard',
            name: 'energieeffizienzhausstandard',
            labelSize: 'big',
            validations: {},
            options: [
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'k.A.',
                value: 'kA'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 40 Plus',
                value: 'kfWEffizienhaus40plus'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 40',
                value: 'kfWEffizienzhaus40'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 55',
                value: 'kfWEffizienzhaus55'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 70',
                value: 'kfWEffizienzhaus70'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 85',
                value: 'kfWEffizienzhaus85'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 100',
                value: 'kfWEffizienzhaus100'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'KfW 115',
                value: 'kfWEffizienzhaus115'
              },
              {
                slideName: slideNames.SLIDE_16,
                formName: formNames.FORM_16_2,
                label: 'Denkmal',
                value: 'kfWEffizienzhausDenkmal'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_17,
    img: '20210625_Teilkauf_2926',
    msg:
      'Fast geschafft!<br /><b>Fanden bereits relevante Modernisierungen an <VAR> statt?</b>',
    msgVar: '',
    forNext: 'table',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_17,
        formName: formNames.FORM_17_1,
        heading: 'Relevante Modernisierungen',
        headingMargin: 'medium',
        type: formTypes.RADIO_TABLE,
        tableHeads: [
          { key: 'key', label: '' },
          { key: 'keine', label: 'Keine' },
          { key: 'teilweise', label: 'Teilweise' },
          { key: 'komplett', label: 'Komplett' }
        ],
        allValues: {
          'Bodenbeläge, Wandverkleidungen & Treppenhaus': '',
          'Strom, (Ab)Wasser, Heizungsanlagen & Heizkörper': '',
          'Bäder und WCs (Fliesen & Sanitärobjekte)': '',
          'Fenster (Rahmen & Isolierverglasung)': '',
          'Heizung (Brenner ggf. Kessel)': '',
          'Raumaufteilung (Grundriss, Zimmergrößen)': '',
          Wärmedämmung: '',
          'Dach (Eindeckungen und Wärmedämmung)': ''
        },
        selectedValue: '',
        inputs: [
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_3,
            label: '<b>Bäder und WCs</b><br>(Fliesen & Sanitärobjekte)',
            name: 'Bäder und WCs (Fliesen & Sanitärobjekte)',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_3,
                name: 'Bäder und WCs (Fliesen & Sanitärobjekte)'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_3,
                name: 'Bäder und WCs (Fliesen & Sanitärobjekte)'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_3,
                name: 'Bäder und WCs (Fliesen & Sanitärobjekte)'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_2,
            label:
              '<b>Strom, (Ab)Wasser, Heizungsanlagen & </br>Heizkörper</b>',
            name: 'Strom, (Ab)Wasser, Heizungsanlagen & Heizkörper',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_2,
                name: 'Strom, (Ab)Wasser, Heizungsanlagen & Heizkörper'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_2,
                name: 'Strom, (Ab)Wasser, Heizungsanlagen & Heizkörper'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_2,
                name: 'Strom, (Ab)Wasser, Heizungsanlagen & Heizkörper'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_1,
            label: '<b>Bodenbeläge, Wandverkleidungen </br>& Treppenhaus</b>',
            name: 'Bodenbeläge, Wandverkleidungen & Treppenhaus',
            options: [
              {
                value: 'keine',
                formName: formNames.FORM_17_1,
                label: 'Keine',
                name: 'Bodenbeläge, Wandverkleidungen & Treppenhaus'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_1,
                name: 'Bodenbeläge, Wandverkleidungen & Treppenhaus'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_1,
                name: 'Bodenbeläge, Wandverkleidungen & Treppenhaus'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_5,
            label: '<b>Heizung</b></br> (Brenner ggf. Kessel)',
            name: 'Heizung (Brenner ggf. Kessel)',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_5,
                name: 'Heizung (Brenner ggf. Kessel)'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_5,
                name: 'Heizung (Brenner ggf. Kessel)'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_5,
                name: 'Heizung (Brenner ggf. Kessel)'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_4,
            label: '<b>Fenster</b></br> (Rahmen & Isolierverglasung)',
            name: 'Fenster (Rahmen & Isolierverglasung)',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_4,
                name: 'Fenster (Rahmen & Isolierverglasung)'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_4,
                name: 'Fenster (Rahmen & Isolierverglasung)'
              },
              {
                value: 'komplett',
                formName: formNames.FORM_17_4,
                label: 'Komplett',
                name: 'Fenster (Rahmen & Isolierverglasung)'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_7,
            label: '<b>Wärmedämmung</b>',
            name: 'Wärmedämmung',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                name: 'Wärmedämmung',
                formName: formNames.FORM_17_7
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_7,
                name: 'Wärmedämmung'
              },
              {
                value: 'komplett',
                formName: formNames.FORM_17_7,
                label: 'Komplett',
                name: 'Wärmedämmung'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_8,
            label: '<b>Dach </b></br>(Eindeckungen und Wärmedämmung)',
            name: 'Dach (Eindeckungen und Wärmedämmung)',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_8,
                name: 'Dach (Eindeckungen und Wärmedämmung)'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_8,
                name: 'Dach (Eindeckungen und Wärmedämmung)'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_8,
                name: 'Dach (Eindeckungen und Wärmedämmung)'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_17,
            formName: formNames.FORM_17_6,
            label: '<b>Raumaufteilung </b></br>(Grundriss, Zimmergrößen)',
            name: 'Raumaufteilung (Grundriss, Zimmergrößen)',
            options: [
              {
                value: 'keine',
                label: 'Keine',
                formName: formNames.FORM_17_6,
                name: 'Raumaufteilung (Grundriss, Zimmergrößen)'
              },
              {
                value: 'teilweise',
                label: 'Teilweise',
                formName: formNames.FORM_17_6,
                name: 'Raumaufteilung (Grundriss, Zimmergrößen)'
              },
              {
                value: 'komplett',
                label: 'Komplett',
                formName: formNames.FORM_17_6,
                name: 'Raumaufteilung (Grundriss, Zimmergrößen)'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    scrollToNext: true,
    slideName: slideNames.SLIDE_18,
    img: '20210625_Teilkauf_2926',
    msg: '<b>Wann wurde die letzte größere Modernisierung durchgeführt?</b>',
    msgVar: '',
    forNext: 'one',
    nextEnabled: false,
    propertyTypes: [propertyTypes.HOUSE, propertyTypes.APARTMENT],
    heading: 'Zeitraum der letzten <br />Modernisierung',
    forms: [
      {
        slideName: slideNames.SLIDE_18,
        formName: formNames.FORM_18_1,
        headingMargin: 'medium',
        inputs: [
          {
            slideName: slideNames.SLIDE_18,
            formName: formNames.FORM_18_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-27.svg',
            imgV2: 'Modernisierung.svg',
            label: 'innerhalb der letzten 15 Jahre',
            name: 'innerhalb der letzten 15 Jahre',
            value: 'letzte 15 Jahre'
          },
          {
            slideName: slideNames.SLIDE_18,
            formName: formNames.FORM_18_1,
            type: formTypes.RADIO_BOX,
            selectedValue: '',
            img: 'item-28.svg',
            imgV2: 'Modernisierung.svg',
            label: 'innerhalb der letzten 25 Jahre',
            name: 'innerhalb der letzten 25 Jahre',
            value: 'letzte 25 Jahre'
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_20,
    img: '7step-02-01-1_ergebnis',
    msg:
      '<b>Geschafft!</b><br />Im nächsten Schritt verraten Sie uns nur noch, wohin das Angebot geschickt werden soll.',
    nextEnabled: true,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_20,
        formName: formNames.FORM_20_1,
        type: formTypes.CALCULATION
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_24,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Fast geschafft!</b><br />Im letzten Schritt benötigen wir nur noch die Adresse der Immobilie, um einen genauen Immobilienwert bestimmen zu können.',
    forNext: 'validation',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    msgVar: '',
    align: 'center',
    gif: true,
    gifImg: 'wohin-sollen.svg',
    forms: [
      {
        slideName: slideNames.SLIDE_24,
        formName: formNames.FORM_19_1,
        img: 'item-30.svg',
        imgV2: 'Standort.svg',
        heading: 'Immobilienadresse',
        heading2MarginTop: 'small',
        heading_2:
          'Nur mit der genauen Immobilienanschrift, können wir Ihnen ein fundiertes und konkretes Angebot für Ihre Immobilie unterbreiten. Die Adresse wird nur intern für die Immobilienbewertung, die Angebotserstellung und den Versand an Sie verwendet.',
        headingMargin: 'big',
        grid: 'space-between',
        additionalInfo_1: '',
        additionalInfo_2:
          'Gerne lassen wir Ihnen unser Angebot auch per E-Mail zukommen. Auf der folgenden Seite können Sie eine Auswahl treffen.',
        inputs: [
          {
            slideName: slideNames.SLIDE_24,
            formName: formNames.FORM_19_1_1,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 255,
              noNumber: true,
              message:
                'Bitte geben Sie die Hausnummer in dem dafür vorgesehenen Feld an.'
            },
            label: 'Strasse',
            name: 'Strasse',
            width: '3-4'
          },
          {
            slideName: slideNames.SLIDE_24,
            formName: formNames.FORM_19_1_2,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 10,
              minOneNumber: true,
              noSingleZero: true,
              message: 'Bitte geben Sie Ihre Hausnummer an.'
            },
            label: 'Hausnummer',
            name: 'Hausnummer',
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_24,
            formName: formNames.FORM_19_2,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            inputType: 'number',
            label: 'Postleitzahl',
            name: 'Postleitzahl',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              numeric: true,
              minLength: 5,
              maxLength: 5,
              message: 'Bitte geben Sie Ihre korrekte Postleitzahl an.'
            },
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_24,
            formName: formNames.FORM_19_3,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Stadt',
            name: 'Stadt',
            width: '3-4',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              noNumber: true,
              message:
                'Bitte geben Sie die Postleitzahl in dem dafür vorgesehenen Feld an.'
            }
          },
          {
            slideName: slideNames.SLIDE_24,
            formName: formNames.FORM_19_4,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Bundesland',
            name: 'Bundesland',
            width: 'wide',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              noNumber: true,
              message:
                'Bitte geben Sie die Postleitzahl in dem dafür vorgesehenen Feld an.'
            }
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_21,
    img: '20210625_Teilkauf_2893',
    msg:
      '<b>Wohin dürfen wir Ihr unverbindliches Angebot kostenfrei schicken?</b><br />Wir melden uns umgehend bei Ihnen!',
    nextButtonImg: 'icon-forward',
    nextButtonText: 'Unverbindliches Angebot anfordern',
    nextButtonMode: 'long',
    forNext: 'validation',
    nextEnabled: false,
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    sendData: true,
    validationOnNext: true,
    forms: [
      {
        slideName: slideNames.SLIDE_21,
        formName: formNames.FORM_21_1,
        grid: 'space-between',
        inputs: [
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_1,
            type: formTypes.SELECT,
            marginSize: 'small',
            placeholder: 'Anrede',
            isInvalid: true,
            validations: {
              required: true,
              message: 'Bitte wählen Sie eine Anrede aus.'
            },
            validationBox: true,
            selectedValue: '',
            name: 'herr',
            width: 'half',
            checkIcon: false,
            options: [
              {
                slideName: slideNames.SLIDE_21,
                formName: formNames.FORM_21_1,
                label: 'Herr',
                value: 'Herr'
              },
              {
                slideName: slideNames.SLIDE_21,
                formName: formNames.FORM_21_1,
                label: 'Frau',
                value: 'Frau'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_2,
            type: formTypes.SELECT,
            placeholder: 'Titel',
            selectedValue: '',
            marginSize: 'small',
            name: 'dr',
            width: 'half',
            isInvalid: false,
            validations: {},
            checkIcon: false,
            options: [
              {
                slideName: slideNames.SLIDE_21,
                formName: formNames.FORM_21_2,
                label: 'Dr.',
                value: 'dr'
              },
              {
                slideName: slideNames.SLIDE_21,
                formName: formNames.FORM_21_2,
                label: 'Prof.',
                value: 'prof'
              },
              {
                slideName: slideNames.SLIDE_21,
                formName: formNames.FORM_21_2,
                label: 'Prof. Dr.',
                value: 'prof. dr.'
              }
            ]
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_3,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Vorname',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              message: 'Bitte geben Sie Ihren Vornamen an.'
            },
            validationBox: true,
            name: 'Vorname',
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_4,
            type: formTypes.TEXT_INPUT,
            selectedValue: '',
            label: 'Nachname',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              message: 'Bitte geben Sie Ihren Nachnamen an.'
            },
            validationBox: true,
            name: 'Nachname',
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_5,
            type: formTypes.TEXT_INPUT,
            inputType: 'email',
            selectedValue: '',
            isInvalid: true,
            autocomplete: true,
            validations: {
              required: true,
              email: true,
              maxLength: 256,
              message: 'Bitte geben Sie Ihre korrekte E-Mail-Adresse an.'
            },
            validationBox: true,
            label: 'E-Mail-Adresse',
            name: 'E-Mail-Adresse',
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_6,
            type: formTypes.TEXT_INPUT,
            inputType: 'tel',
            selectedValue: '',
            label: 'Telefonnummer',
            name: 'Telefonnummer',
            isInvalid: true,
            autocomplete: true,
            validations: {
              noSpecialCharacters: false,
              required: true,
              minLength: 4,
              maxLength: 256,
              phoneNumber: true,
              message: 'Bitte geben Sie Ihre korrekte Telefonnummer an.'
            },
            validationBox: true,
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_7,
            type: formTypes.CHECKBOX,
            disabled: false,
            selectedValue: false,
            validations: { required: false },
            label: 'Das Angebot an eine andere Adresse senden',
            name: 'Das Angebot an eine andere Adresse senden',
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_13,
            type: formTypes.CHECKBOX,
            selectedValue: false,
            disabled: false,
            validations: { required: false },
            label: 'Das Angebot vorab via E-Mail erhalten',
            name: 'Das Angebot nur per E-Mail senden',
            width: 'half'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_8_1,
            type: formTypes.TEXT_INPUT,
            disabled: true,
            selectedValue: '',
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 255,
              noNumber: true,
              message:
                'Bitte geben Sie die Hausnummer in dem dafür vorgesehenen Feld an.'
            },
            validationBox: true,
            label: 'Strasse',
            name: 'Strasse',
            width: '3-4'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_8_2,
            type: formTypes.TEXT_INPUT,
            disabled: true,
            selectedValue: '',
            autocomplete: true,
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 10,
              minOneNumber: true,
              noSingleZero: true,
              message: 'Bitte geben Sie Ihre Hausnummer an.'
            },
            validationBox: true,
            label: 'Hausnummer',
            name: 'Hausnummer',
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_9,
            type: formTypes.TEXT_INPUT,
            disabled: true,
            autocomplete: true,
            selectedValue: '',
            label: 'Postleitzahl',
            validations: {
              noSpecialCharacters: true,
              required: true,
              numeric: true,
              minLength: 5,
              maxLength: 5,
              message: 'Bitte geben Sie Ihre korrekte Postleitzahl an.'
            },
            validationBox: true,
            name: 'Postleitzahl',
            width: '1-4'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_10,
            type: formTypes.TEXT_INPUT,
            autocomplete: true,
            disabled: true,
            selectedValue: '',
            label: 'Stadt',
            validations: {
              noSpecialCharacters: true,
              required: true,
              maxLength: 256,
              noNumber: true,
              message:
                'Bitte geben Sie die Postleitzahl in dem dafür vorgesehenen Feld an.'
            },
            validationBox: true,
            name: 'Stadt',
            width: '3-4'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_11,
            type: formTypes.TEXTAREA,
            selectedValue: '',
            label: 'Ihre optionale Nachricht an uns',
            isInvalid: false,
            validations: {
              noAngleBrackets: true,
              maxLength: 1024,
              message: 'Bitte prüfen Sie Ihre optionale Nachricht an uns.'
            },
            name: 'Ihre Nachricht an uns'
          },
          {
            slideName: slideNames.SLIDE_21,
            formName: formNames.FORM_21_12,
            type: formTypes.CHECKBOX,
            selectedValue: false,
            isInvalid: true,
            margin: 'top',
            validations: {
              required: true,
              message: 'Bitte aktivieren Sie die Checkbox.'
            },
            validationBox: true,
            label:
              'Ja, ich möchte auf mich zugeschnittene Angebote und Neuigkeiten der Deutsche Teilkauf GmbH erhalten und erteile dazu mein Einverständnis. Ich kann meine Einwilligung jederzeit mit Wirkung für die Zukunft und ohne Angabe von Gründen widerrufen; z.B. durch Klick auf den Abmeldelink am Ende jeder Info-Mail.',
            name:
              'Ja, ich möchte auf mich zugeschnittene Angebote und Neuigkeiten der Deutsche Teilkauf GmbH erhalten und erteile dazu mein Einverständnis. Ich kann meine Einwilligung jederzeit mit Wirkung für die Zukunft und ohne Angabe von Gründen widerrufen; z.B. durch Klick auf den Abmeldelink am Ende jeder Info-Mail.'
          }
        ]
      }
    ]
  },
  {
    slideName: slideNames.SLIDE_22,
    img: '20210625_Teilkauf_2893',
    msg:
      'Haben Sie vielen Dank!<br />Ihre Anfrage wurde an uns gesendet.<br /><b>Wir lassen Ihnen zeitnah unser Angebot zukommen.</b>',
    msgVar: '',
    // backButton: false,
    nextButton: false,
    // nextEnabled: true,
    // nextButtonImg: false,
    // paddingLeft: 'medium',
    // nextButtonLink: 'https://deutsche-teilkauf.de/news/',
    // nextButtonText: 'Zu den Teilverkaufs-News',
    align: 'center',
    propertyTypes: [propertyTypes.APARTMENT, propertyTypes.HOUSE],
    forms: [
      {
        slideName: slideNames.SLIDE_22,
        formName: formNames.FORM_22_1,
        type: formTypes.TEXT,
        text: 'weiterführende Links oder Infos hier'
      }
    ]
  }
]

export { data_hausanker }
